import { getEmbedThemeProperty } from 'modules/embed/utils'
import { toggleConversationHistory } from 'modules/view/actions'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

interface ConversationHistoryToggle {
  onToggleConversationHistory: (open: boolean) => void,
  conversationHistoryOpen: boolean,
  conversationHistoryEnabled: boolean
}

const useConversationHistoryToggle = (): ConversationHistoryToggle => {
  const dispatch = useDispatch()

  const conversationHistoryEnabled: boolean = useSelector(state =>
    getEmbedThemeProperty(state.embed, 'conversationHistoryEnabled', true)
  )

  const conversationHistoryOpen: boolean = useSelector(state => (
    state.view.conversationHistoryOpen
  ))

  const onToggleConversationHistory = useCallback((open: boolean) => {
    dispatch(toggleConversationHistory({
      conversationHistoryOpen: open
    }))
  }, [dispatch])

  return {
    onToggleConversationHistory,
    conversationHistoryOpen,
    conversationHistoryEnabled
  }
}


export default useConversationHistoryToggle
